/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * The following types are accepted for ID documents. 
- Permanent HKID
- Valid Passport
- China National ID
- Exit-Entry Permit for Travelling to and from Hong Kong and Macao (EEP)
- Japanese National ID
- Japanese Driving License
- Malaysian National ID

 */
export type CardholderInfoDocumentType = typeof CardholderInfoDocumentType[keyof typeof CardholderInfoDocumentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardholderInfoDocumentType = {
  passport: 'passport',
  'drivers-license': 'drivers-license',
  'national-id': 'national-id',
} as const;
